import { isNumber } from './piFormat.js';

export const VIEWPORT_MARGIN = 8;
export const ANCHOR_GAP = 6;

const number = (value, fallback) => (isNumber(value) ? value : fallback);

export const escapeClosesPanel = (open, event) => {
  if (!open) return false;
  if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
  return true;
};

export const popoverPosition = (box) => {
  const source = box || {};
  const margin = number(source.margin, VIEWPORT_MARGIN);
  const gap = number(source.gap, ANCHOR_GAP);
  const viewportWidth = number(source.viewportWidth, 0);
  const viewportHeight = number(source.viewportHeight, 0);
  const width = Math.max(0, Math.min(number(source.panelWidth, 0), viewportWidth - margin * 2));
  const height = number(source.panelHeight, 0);
  const anchorLeft = number(source.anchorLeft, 0);
  const anchorRight = number(source.anchorRight, anchorLeft);
  const anchorTop = number(source.anchorTop, 0);
  const anchorBottom = number(source.anchorBottom, anchorTop);
  const preferred = source.align === 'right' ? anchorRight + margin - width : anchorLeft - margin;
  const left = Math.max(margin, Math.min(preferred, viewportWidth - margin - width));
  const fitsBelow = anchorBottom + gap + height <= viewportHeight - margin;
  const fitsAbove = anchorTop - gap - height >= margin;
  let top = anchorBottom + gap;
  let up = false;
  if (!fitsBelow && fitsAbove) {
    top = anchorTop - gap - height;
    up = true;
  } else if (!fitsBelow) {
    top = Math.max(margin, viewportHeight - margin - height);
  }
  return { left: left, top: top, up: up };
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piPopover.js